import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5ece21a4")

_pushScopeId("data-v-5ece21a4")
const _hoisted_1 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.isShowThirdPartyDeviceUI)
      ? (_openBlock(), _createBlock(_component_property_bread_crumb, {
          key: 0,
          headers: _ctx.breadCrumbHeaders
        }, null, 8, ["headers"]))
      : _createCommentVNode("", true),
    (_ctx.isShowThirdPartyDeviceUI)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabsButtonData, (item, key) => {
            return (_openBlock(), _createBlock(_component_cus_button, {
              class: "button-tab",
              key: key,
              type: _ctx.tabsButtonName===key?'blue':'default',
              onClick: ($event: any) => (_ctx.changeTabsButton(key))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["type", "onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: _ctx.isShowThirdPartyDeviceUI?'shell':''
    }, [
      (_ctx.tabsButtonName==='thirdPartyDevices')
        ? (_openBlock(), _createBlock(_component_el_tabs, {
            key: 0,
            onTabClick: _ctx.changeTab,
            modelValue: _ctx.tabsActiveName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.tabsActiveName = $event))
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabsData, (item) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  name: item.name,
                  key: item.name,
                  label: item.label
                }, null, 8, ["name", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["onTabClick", "modelValue"]))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tabsButtonName==='intercom'
                    ?_ctx.tabsButtonData[_ctx.tabsButtonName].component
                    :_ctx.tabsData[_ctx.tabsActiveName].component), {
        isShowBreadCrumb: !_ctx.isShowThirdPartyDeviceUI,
        type: _ctx.type,
        deviceType: _ctx.deviceType
      }, null, 8, ["isShowBreadCrumb", "type", "deviceType"]))
    ], 2)
  ]))
})